import AdminView from './AdminView';
import AssetstoresView from './AssetstoresView';
import CollectionView from './CollectionView';
import CollectionsView from './CollectionsView';
import FilesystemImportView from './FilesystemImportView';
import FolderView from './FolderView';
import FrontPageView from './FrontPageView';
import GroupView from './GroupView';
import GroupsView from './GroupsView';
import ItemView from './ItemView';
import PluginsView from './PluginsView';
import S3ImportView from './S3ImportView';
import SearchResultsView from './SearchResultsView';
import SystemConfigurationView from './SystemConfigurationView';
import UserAccountView from './UserAccountView';
import UserView from './UserView';
import UsersView from './UsersView';

export {
    AdminView,
    AssetstoresView,
    CollectionView,
    CollectionsView,
    FilesystemImportView,
    FolderView,
    FrontPageView,
    GroupView,
    GroupsView,
    ItemView,
    PluginsView,
    S3ImportView,
    SearchResultsView,
    SystemConfigurationView,
    UserAccountView,
    UserView,
    UsersView
};



// WEBPACK FOOTER //
// ./src/views/body/index.js